<template>
  <div id="error-messages">
    <span>
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      required: true,
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
#error-messages {
  color: $error-color;
  display: flex;
  justify-content: center;
}
</style>
